import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNodeId } from '@xyflow/react';

// Hooks
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { InputRichVariavel } from '~/utils/InputRichVariavel';
import { CustomHandle } from '~/utils/CustomHandle';

// Node de exibição de mensagem para o usuário
// Este componente permite que o usuário exiba uma mensagem personalizada na tela, com opções de confirmação
export const MostrarNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const [inputValue, setInputValue] = useState(data.inputValue || "");
    const [isExpanded, setIsExpanded] = useState(false);
    const [mode, setMode] = useState(data.mode || "confirm");
    const [displayDuration, setDisplayDuration] = useState(data.displayDuration || 3);
    const [holdExecution, setHoldExecution] = useState(data.holdExecution || false);

    // Atualiza os estados com os valores do data para o undo/redo
    useEffect(() => { setInputValue(data.inputValue || ""); }, [data.inputValue]);
    useEffect(() => { setMode(data.mode || "confirm"); }, [data.mode]);
    useEffect(() => { setDisplayDuration(data.displayDuration || 3); }, [data.displayDuration]);
    useEffect(() => { setHoldExecution(data.holdExecution || false); }, [data.holdExecution]);
    
    const [listaPendencias, setListaPendencias] = useState([]);
    const conferePendencias = () => {
        const pendencias = [];
        if (!inputValue) pendencias.push("Frase não preenchida");
        setListaPendencias(pendencias);
        return pendencias;
    };
    const handleInputChange = (v) => {
        setInputValue(v);
        onNodesChange([{ id, type: 'update', data: { inputValue: v } }]);
    };
    const handleModeChange = (newMode) => {
        setMode(newMode);
        onNodesChange([{ id, type: 'update', data: { mode: newMode } }]);
    };
    const handleDurationChange = (e) => {
        const v = e.target.value;
        setDisplayDuration(v);
        onNodesChange([{ id, type: 'update', data: { displayDuration: v } }]);
    };
    const handleHoldChange = (e) => {
        const v = e.target.checked;
        setHoldExecution(v);
        onNodesChange([{ id, type: 'update', data: { holdExecution: v } }]);
    };

    useEffect(() => { conferePendencias(); }, [inputValue]);

    return (
        <div className={`node node-mostrar ${data.highlighted ? 'highlighted' : ''}`}>
            <div className="titulo-node"><FontAwesomeIcon icon="fa-solid fa-desktop" />{data.label.toUpperCase()}</div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert("Executar")}><FontAwesomeIcon icon="fa-solid fa-circle-play" /></button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal">
                    <div className="body-node"></div>
                    <span className="icon">Frase:</span>
                    <div style={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
                        <button 
                            onClick={() => setIsExpanded(!isExpanded)} 
                            style={{ 
                                marginRight: "8px", 
                                padding: "8px", 
                                cursor: "pointer",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                background: "#fafafa",
                                minWidth: "32px",
                                minHeight: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            title={isExpanded ? "Minimizar editor" : "Expandir para textarea"}
                        >
                            {isExpanded ? <FontAwesomeIcon icon="fa-solid fa-minus" /> : <FontAwesomeIcon icon="fa-solid fa-plus" />}
                        </button>
                        <div style={{ flex: 1, maxWidth: '300px', minWidth: '250px', width: '100%' }}>
                            <InputRichVariavel
                                value={inputValue}
                                onChange={handleInputChange}
                                placeholder="Mensagem para o usuário ou arraste uma variável"
                                multiline={isExpanded}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column' }}>
                        <label>
                            <input type="radio" value="confirm" checked={mode === 'confirm'} onChange={() => handleModeChange('confirm')} /> Aguardar confirmação
                        </label>
                        <label>
                            <input type="radio" value="time" checked={mode === 'time'} onChange={() => handleModeChange('time')} /> Mostrar por
                            <input type="text" value={displayDuration} onChange={handleDurationChange} style={{ width: '50px', margin: '0 5px' }} />seg
                        </label>
                        {mode === 'time' && (
                            <label style={{ marginLeft: '20px' }}>
                                <input type="checkbox" checked={holdExecution} onChange={handleHoldChange} /> Segurar execução
                            </label>
                        )}
                    </div>
                    <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};